import type { FC } from 'react';

import { useGetActionById } from '@/hooks/queries';

type Props = {
  actionId: string | undefined;
};

const Breadcrumb: FC<Props> = ({ actionId }) => {
  const { data } = useGetActionById(actionId ?? '', !actionId);

  return <>{data?.action?.[0]?.Title}</>;
};

export default Breadcrumb;
